
import { defineComponent } from '@vue/composition-api';
import { LinkButton } from '@fc/angie-ui';
import { metaData } from '~/configuration/metaData';
import HeroSection from '~/components/v5/HeroSection.vue';
import MembersSection from '~/components/v5/results/MembersSection.vue';
import TheScienceSection from '~/components/v5/results/TheScienceSection.vue';
import InTheNewsSection from '~/components/v5/results/InTheNewsSection.vue';

export default defineComponent({
  name: 'TheResultsPage',
  components: {
    LinkButton,
    HeroSection,
    MembersSection,
    TheScienceSection,
    InTheNewsSection,
  },
  head: {
    ...metaData.home, // TODO: update with results page metadata
  },
  setup() {
    const heroData = {
      title: '20,000 + Members.',
      titleSecondLine: 'One Standard.',
      subtitle: 'More than 20k members have turned rounds into results - stronger bodies, steadier minds – and found the fighter within.',
      videoUrl: 'https://cdn-b.joinfightcamp.com/videos/TheResults_Hero_Video_NoAudio_001.mp4',
      mobileVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/Hero_Video_Results_9x16.mp4',
    };

    const endHeroData = {
      title: 'Write your Day 1',
      subtitle: 'More than 20k members have turned rounds into results and found the fighter within.',
      imageUrl: 'https://a.storyblok.com/f/152150/5653x3769/e2b5448d91/monica_stills-118.jpg',
      imageAlt: 'Woman boxing indoors, wearing white gloves, focused on punching a FightCamp bag in a sunlit room.',
    };

    return {
      heroData,
      endHeroData,
    };
  },
});
